import { useRef, useCallback } from "react";

/**
 * Wraps an async action so a second call while the first is in flight is ignored.
 * Prevents duplicate network requests from double-clicks or double event firing.
 */
export function useSingleFlight() {
  const inFlight = useRef(false);

  const run = useCallback(async (fn) => {
    if (inFlight.current) return undefined;
    inFlight.current = true;
    try {
      return await fn();
    } finally {
      inFlight.current = false;
    }
  }, []);

  return run;
}
